export * from './profil-detail.component';
export * from './profil-detail.component.module';